import ModelTypeConstants, {STORABLE_ITEM_TYPES} from 'constants/ModelTypeConstants';
import APIUtil from 'util/APIUtil';

/**
 * Legacy implementation of `isArchivable` that is not Core Object aware. Prefer `isArchivable` from
 * `isArchivable.ts` instead.
 */
export default function canHaveArchiveRecord(itemId: string): boolean {
  // Corresponds to all models that use `HasArchiveRecord`
  const itemType = APIUtil.apiIdToType(itemId);
  return [
    ...STORABLE_ITEM_TYPES,
    ModelTypeConstants.BASIC_FOLDER_ITEM,
    ModelTypeConstants.BULK_ASSEMBLY,
    ModelTypeConstants.ENTRY,
    ModelTypeConstants.FOLDER,
    ModelTypeConstants.MIXTURE,
    ModelTypeConstants.MOLECULE,
    ModelTypeConstants.PROCESS,
    ModelTypeConstants.PROTEIN,
    ModelTypeConstants.PROTOCOL,
    ModelTypeConstants.SEQUENCE,
    ModelTypeConstants.STUDY,
    ModelTypeConstants.SOURCE,
    ModelTypeConstants.ASSAY_RUN,
    ModelTypeConstants.BATCH,
    ModelTypeConstants.CONNECTION,
    ModelTypeConstants.PROCESS_TASK,
    ModelTypeConstants.PROCESS_OUTPUT,
    ModelTypeConstants.MONOMER,
    ModelTypeConstants.SALT,
    ModelTypeConstants.SOLVENT,
    ModelTypeConstants.TEMPLATE,
    ModelTypeConstants.SUBTEMPLATE,
    ModelTypeConstants.TEMPLATE_COLLECTION,
    ModelTypeConstants.ANALYSIS,
    ModelTypeConstants.ASSAY_SCHEMA,
    ModelTypeConstants.TAG_SCHEMA,
    ModelTypeConstants.BOX_SCHEMA,
    ModelTypeConstants.PLATE_SCHEMA,
    ModelTypeConstants.LOCATION_SCHEMA,
    ModelTypeConstants.REQUEST_TASK_SCHEMA,
    ModelTypeConstants.STUDY_SCHEMA,
  ].includes(itemType);
}
